import * as ActionTypes from "../Types/ActionTypes";

const initialState = {
  states: [],
  districts: [],
  talukas: [],
  city: [],
  areas: [],
  areaPincodes: [],
  isLoading: false,
  error: null,
};

export const StatesReducer = (state = initialState, action) => {
  console.log("Reducer Action:", action); // Debug log
  switch (action.type) {
    // States
    case ActionTypes.STATE_LOADING:
      return { ...state, isLoading: true, error: null, states: [] };
    case ActionTypes.FETCH_STATES:
      return { ...state, isLoading: false, error: null, states: action.payload };
    case ActionTypes.STATE_FAILED:
      return { ...state, isLoading: false, error: action.payload, states: [] };

    // Districts
    case ActionTypes.DISTRICTS_LOADING:
      return { ...state, isLoading: true, error: null, districts: [] };
    case ActionTypes.FETCH_DISTRICTS:
      return { ...state, isLoading: false, error: null, districts: action.payload };
    case ActionTypes.DISTRICTS_FAILED:
      return { ...state, isLoading: false, error: action.payload, districts: [] };

    // Talukas
    case ActionTypes.TALUKAS_LOADING:
      return { ...state, isLoading: true, error: null, talukas: [] };
    case ActionTypes.FETCH_TALUKAS:
      return { ...state, isLoading: false, error: null, talukas: action.payload };
    case ActionTypes.TALUKAS_FAILED:
      return { ...state, isLoading: false, error: action.payload, talukas: [] };

    // City
    case ActionTypes.CITY_LOADING:
      return { ...state, isLoading: true, error: null, city: [] };
    case ActionTypes.FETCH_CITY:
      return { ...state, isLoading: false, error: null, city: action.payload };
    case ActionTypes.CITY_FAILED:
      return { ...state, isLoading: false, error: action.payload, city: [] };

    // Areas
    case ActionTypes.AREAS_LOADING:
      return { ...state, isLoading: true, error: null, areas: [] };
    case ActionTypes.FETCH_AREAS:
      return { ...state, isLoading: false, error: null, areas: action.payload };
    case ActionTypes.AREAS_FAILED:
      return { ...state, isLoading: false, error: action.payload, areas: [] };

    // Area Pincodes
    case ActionTypes.AREA_PINCODES_LOADING:
      return { ...state, isLoading: true, error: null, areaPincodes: [] };
    case ActionTypes.FETCH_AREA_PINCODES:
      return { ...state, isLoading: false, error: null, areaPincodes: action.payload };
    case ActionTypes.AREA_PINCODES_FAILED:
      return { ...state, isLoading: false, error: action.payload, areaPincodes: [] };

    default:
      return state;
  }
};